<template>
    <div class="Right-Content">
        <Header></Header>
        <div class="content">
            <router-view/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Right-Content",
    }

</script>

<style lang="less" scoped>
    .Right-Content {

        .header {
            /*position: fixed;*/
            top: 0;
            height: 60px;
            width: 100%;
        }

        .content {
            width: 100%;
        }
    }


</style>
